import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http'

const state: RiskProfileTemplateState = {
  selectedTemplate: {
    name: '',
    description: '',
  },
  riskProfileTree: null
}

const getters: GetterTree<RiskProfileTemplateState, RootState> = {
  selectedTemplate(state): Nullable<Model> {
    const { selectedTemplate } = state;
    return selectedTemplate;
  },
  // pluck all the risk profile items from each sections and their sub-sections
  riskProfileTemplateItems(state) {
    if (state.riskProfileTree) {
      const subSection = [].concat(...state.riskProfileTree)
        .map((section: RiskProfileSection) => section.sub_sections)
        .flat()
      return [].concat(...subSection)
        .map((section: RiskProfileSubSection) => section.items).flat() || []
    }
    return []
  },
}

const actions: ActionTree<RiskProfileTemplateState, RootState> = {
  searchForTemplateName(context, name) {
    if (name.length === 0) {
      return null;
    }

    return http.v1.rpt.fetchList({
      params: {
        name: name,
      }
    })
  },
  fetchFullStructure({ commit }) {
    return http.v1.rpt.fetchFullStructure().then(
      ({ data }) => {
        const payload = data.data;
        const tree = payload.risk_profile.map(item => {
          item.title = item.name;
          delete item.name;
          return item;
        });
        commit("SET_RISK_PROFILE_TREE", tree);
        commit("RiskProfile/SET_RPI_BP_MAP", payload.rpi_map_bp, { root: true });
        commit("RiskProfile/SET_RPI_QG_MAP", payload.rpi_map_qg, { root: true });
        commit("RiskProfile/SET_BODY_PARTS", payload.body_parts, { root: true });
        commit("RiskProfile/SET_QUESTION_GROUPS", payload.question_groups, { root: true });
      }
    );
  },
  fetchFullRiskProfileTemplate({ commit }, oid) {
    return http.v1.rpt.fetchFullRiskProfileTemplate(oid).then(
      ({ data }) => {
        const payload = data.data;
        const tree = payload.risk_profile.map(item => {
          item.title = item.name;
          delete item.name;
          return item;
        });
        commit("SET_RISK_PROFILE_TREE", tree);
        commit("RiskProfile/SET_RPI_BP_MAP", payload.rpi_map_bp, { root: true });
        commit("RiskProfile/SET_RPI_QG_MAP", payload.rpi_map_qg, { root: true });
        commit("RiskProfile/SET_BODY_PARTS", payload.body_parts, { root: true });
        commit("RiskProfile/SET_QUESTION_GROUPS", payload.question_groups, { root: true });
      }
    );
  },
  create(context, payload) {
    return http.v1.rpt.create(payload)
  },
  fetchList(context, options) {
    return http.v1.rpt.fetchList(options).then(({ data }) => {
      const payload = data
      const items = payload.data.data
      return {
        items,
        total: payload.data.total,
      }
    })
  },
  fetch({ commit }, oid) {
    return http.v1.rpt.fetch(oid, {
      params: {
        expand: ["anzsco_occupation_list"]
      }
    }).then(({ data }) => {
      const payload = data.data;
      commit("SET_SELECTED_TEMPLATE", payload);
    });
  },
  update({ state }, payload) {
    if (!state.selectedTemplate) {
      return false
    }

    return http.v1.rpt.update(state.selectedTemplate.object_id, payload)
  }
}

const mutations: MutationTree<RiskProfileTemplateState> = {
  SET_SELECTED_TEMPLATE(state, payload) {
    state.selectedTemplate = payload
  },
  SET_RISK_PROFILE_TREE(state, payload) {
    state.riskProfileTree = payload
  },
  CLEAR_STATE(state) {
    state.selectedTemplate = {
      name: '',
      description: '',
    }
    state.riskProfileTree = null
  },
  RESET_STATE(state, payload: Array<string>) {
    for (let i = 0; i < payload.length; i++) {
      const data: string = payload[i]
      state[data] = null
    }
  },
}

const riskProfileTemplate: Module<RiskProfileTemplateState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default riskProfileTemplate